const IST = { timeZone: "Asia/Kolkata" };

export const fmtMin = (m) => {
  if (m === null || m === undefined || Number.isNaN(m)) return "—";
  const v = Math.round(m);
  if (v >= 60) return `${Math.floor(v / 60)}h ${v % 60}m`;
  return `${v}m`;
};

export const fmtTime = (iso) => {
  if (!iso) return "—";
  return new Date(iso).toLocaleTimeString("en-IN", { ...IST, hour: "2-digit", minute: "2-digit" });
};

export const fmtDT = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return `${d.toLocaleDateString("en-IN", { ...IST, day: "2-digit", month: "short" })} ${d.toLocaleTimeString("en-IN", { ...IST, hour: "2-digit", minute: "2-digit" })}`;
};

// minutes between two ISO timestamps (restored: OrderDetail.jsx imports this)
export const mins = (startIso, endIso) => {
  if (!startIso || !endIso) return null;
  return (new Date(endIso).getTime() - new Date(startIso).getTime()) / 60000;
};

export const elapsedMin = (startIso, pauses = []) => {
  if (!startIso) return 0;
  let pausedMs = 0;
  const nowMs = Date.now();
  for (const p of pauses) {
    if (p.paused_at) {
      const end = p.resumed_at ? new Date(p.resumed_at).getTime() : nowMs;
      pausedMs += end - new Date(p.paused_at).getTime();
    }
  }
  return Math.max(0, (nowMs - new Date(startIso).getTime() - pausedMs) / 60000);
};
